// Page expandableTableRowKeyText
$(document).ready(function() {
	let $controlPlus = $('.tableRowColspanFiveWithExpandableRowList a.controlPlus');
	let $controlMinus = $('.tableRowColspanFiveWithExpandableRowList a.controlMinus');

	if (!$controlPlus.length || !$controlMinus.length) {
		return;
	}

	$controlPlus.click(function () {
		let $this = $(this);

		$('.tableRowColspanFiveWithExpandableRowList').removeClass('expanded');
		$('.tableRowKeyFourValues').removeClass('expanded');
		$this.parents('.tableRowColspanFiveWithExpandableRowList').addClass('expanded');
		$('.tableRowKeyFourValues[data-expandable-row-list=' + $this.data('expandable-row-list') + ']').addClass('expanded');

		$('html, body').animate({
			scrollTop: ($('body>div.content').offset().top * -1) + $this.parents('.tableRowColspanFiveWithExpandableRowList').offset().top - 10,
		}, 700);

		return false;
	});

	$controlMinus.click(function () {
		let $this = $(this);

		$('.tableRowColspanFiveWithExpandableRowList').removeClass('expanded');
		$('.tableRowKeyFourValues').removeClass('expanded');

		$('html, body').animate({
			scrollTop: ($('body>div.content').offset().top * -1) + $this.parents('.tableRowColspanFiveWithExpandableRowList').offset().top - 10,
		}, 700);

		return false;
	});
});
